import axiosInstance from 'src/utils/axios';
import type { ExistingSurveyFile } from 'src/redux/slices/Interview/types';

export async function deleteSurveyFile(
  surveyId: number,
  surveyAnswerId: number,
  fileId: number
): Promise<void> {
  await axiosInstance.delete(
    `/v2/questionnaire/survey/${surveyId}/answer/${surveyAnswerId}/file/${fileId}/`
  );
}

export async function getSurveyFileFromRenterFile(
  renterFileId: number
): Promise<ExistingSurveyFile> {
  const response = await axiosInstance.get<{
    id: number;
    filename: string;
    pdf_file_url: string;
    status: number;
    survey_answer: number;
  }>(`/v2/interview/survey-file/by-renter-file/${renterFileId}/`);
  const data = response.data;
  return {
    file_id: data.id,
    file_name: data.filename,
    pdf_file_url: data.pdf_file_url,
    survey_answer_id: data.survey_answer,
    status: data.status,
    created_at: new Date().toISOString(),
  };
}
